// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.11.0",
  date: "2026-09-30T14:58:21.610Z",
  gitInfo: {
    dirty: false,
    raw: "c45a0d702",
    hash: "c45a0d702",
    distance: null,
    tag: null,
    semver: null,
    suffix: "c45a0d702",
    semverString: null
  }
};
/* tslint:enable */
